import { X } from 'lucide-react';
import { Badge } from '../ui/badge';

interface CoilChipProps {
    coil: string;
    onRemove?: () => void;
}

export default function CoilChip({ coil, onRemove }: CoilChipProps) {
    return (
        <Badge className="min-w-0 max-w-full gap-1 text-xs font-medium border-foreground/25 bg-foreground/[0.08] text-foreground hover:bg-foreground/[0.08]">
            <span className="truncate">{coil}</span>
            {onRemove && (
                <button
                    type="button"
                    onClick={onRemove}
                    className="ml-0.5 rounded-full p-0.5 hover:bg-gray-400/30"
                >
                    <X className="h-3 w-3" />
                </button>
            )}
        </Badge>
    );
}
